import { render, staticRenderFns } from "./CreaNegocio.vue?vue&type=template&id=eb85fa64&"
import script from "./CreaNegocio.vue?vue&type=script&lang=ts&"
export * from "./CreaNegocio.vue?vue&type=script&lang=ts&"
import style0 from "./CreaNegocio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports